import DepositContainer from "@/components/shared/deposit/DepositContainer";
import { useMyWalletAndAssets } from "@/hooks";
import { useAppSelector } from "@/store/hooks";
import { Loader2 } from "lucide-react";

const UserDeposit = () => {
  const { user } = useAppSelector((state) => state.auth);
  const userId = user?.id;

  const {
    data: wallet,
    isLoading,
    isError,
    refetch,
  } = useMyWalletAndAssets(userId!);

  if (isLoading) {
    return (
      <div className="flex min-h-[400px] items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (isError || !wallet) {
    return (
      <div className="flex min-h-[400px] flex-col items-center justify-center gap-3">
        <p className="text-sm text-muted-foreground">Unable to load wallet.</p>

        <button
          type="button"
          onClick={() => refetch()}
          className="rounded-lg bg-primary px-4 py-2 text-sm font-medium"
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="mt-10">
      <DepositContainer
        wallet={wallet}
        assets={wallet.assets.filter((asset) => !asset.token.isFiat) ?? []}
      />
    </div>
  );
};

export default UserDeposit;
